import { Component, Input, OnInit } from '@angular/core';
import { Globals } from 'projects/core/src/globals';
import { InventoriesService } from '../../services/inventories.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.sass']
})

export class DocumentsComponent implements OnInit {

  @Input()
  id_address:number;

  @Input()
  mode:string;

  @Input()
  showCard=true;

  @Input()
  modalWindow:any={};

  @Input()
  recordSelected:any={};

  tab=1;

  get user(){
    return Globals.user;
  }

  inventories=[];

  constructor(
    private InventoriesService: InventoriesService
    
  ) {
   }

  ngOnInit(): void {

    this.InventoriesService.getInventories().subscribe((items)=>{
      this.inventories=items;
    });

  }

  checkPermissions(permissionname: String){
    return Globals.permissions.checkPermission('documents',permissionname);
  }

  isModuleEnabled(modulename: any){
    return Globals.parameters.get(modulename)?true:false;
 }
  

}